module.exports = require('./vendor/dat.gui')
module.exports.color = require('./vendor/dat.color')


//////////////////
// WEBPACK FOOTER
// ./~/dat-gui/index.js
// module id = 18
// module chunks = 0